import React, { useEffect } from 'react';
import {
	Divider, Row, Button, Popconfirm
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import ResetPasswordForm from './resetPasswordForm';
import { recoverPassword } from '../../actions/authentication';
import CardFormContainer from '../../containers/card-form-container/cardFormContainer';
import { logout } from '../../actions/authentication';
import { getUser } from '../../actions/user';

const ResetPasswordScreen = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const isLogging = useSelector((state) => state.authentication.idLoadingRecoverPassword);
	const type = useSelector((state) => state.user.user.role);
	const handleSubmit = (form) => {
		console.log(type)
		dispatch(recoverPassword(form, () => history.push('/login'), type));
	}

	const handleLogoutClick = () => {
		history.push('/login');
		return dispatch(logout());
	};

	useEffect(() => {
		dispatch(getUser());
	}, []);

	return (
		<CardFormContainer title="Reestablecer contraseña">
			<p> {'Debe cambiar su contraseña para ingresar al sistema'} </p>
			<ResetPasswordForm onSubmit={handleSubmit} isLoading={isLogging} />
			<Divider />
			<Row justify="center">
				<Popconfirm
					title="¿Estás seguro que desea cerrar sesión?"
					onConfirm={handleLogoutClick}
					onCancel={() => { }}
					okText="Si"
					cancelText="No"
				>
					<Button type="primary" ghost >Cerrar sesión</Button>
				</Popconfirm>
			</Row>
		</CardFormContainer>
	);
};

export default ResetPasswordScreen;
